import { render, staticRenderFns } from "./GroupClientList.vue?vue&type=template&id=acc5acee"
import script from "./GroupClientList.vue?vue&type=script&lang=js"
export * from "./GroupClientList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports